/**
 * The follow mark: an act whose dates you want on the calendar.
 *
 * One component, for the reason `Bookmark` is one. This was drawn out four times — `Marks`,
 * the month chip, the list row and the briefing — and the four had drifted: three share a
 * path and `Marks` has a different one, so the star on a front-page card was a visibly
 * different shape from the star on the same gig in the month grid. The comment in
 * `MonthGrid` even claimed "the same path the compact row draws", which was true of the
 * compact row and not of the card.
 *
 * The majority path wins, which is the calendar's. Nothing about it is better; it is on
 * three surfaces to one, so it is the shape most of the site already means by "starred".
 *
 * Drawn, not typed, for the same reason as everything else here: `★` and `☆` are glyphs of
 * different weights in most faces, so a control that swaps one for the other changes size as
 * it is pressed.
 */
export function Star({
  fill,
  className,
  size = 15,
  strokeWidth = 2,
}: {
  fill: boolean
  className?: string
  size?: number
  strokeWidth?: number
}) {
  return (
    <svg
      {...(className ? { className } : {})}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={fill ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 3.5 14.9 9.4 21.5 10.3 16.7 14.9 17.9 21.4 12 18.3 6.1 21.4 7.3 14.9 2.5 10.3 9.1 9.4Z" />
    </svg>
  )
}
